export class ManageMemoModel {
    public id: string;
    public title: string;
    public status: string;
    public createBy: string;
    public publishDate: string;
    public publishBy: string;
    public isPublish : boolean = false;
    public isConfirm : boolean;
    public memo: string;
    public country: any[] = null;
    public centre: any[]  = null;
    public role: any[] = null;
    public clinicLogoName: string;
    public IsClinicLogoDelete: boolean;
}

export const MemoStatus = {
    Unpublished  :  'Unpublished',
    Published: 'Published'
}

export class WorldTravelNewModel{
    public sourceid : string;
    public receiveddate : string;
    public headline : string;
    public  details : string;
    public countryname :string;
    public newscategoryname :string;
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/centre/manage-memo.model.ts